import { Feed, NoMoreFeedItemsCallbackProp } from "@components/feed";
import { PageSection } from "@components/layout/PageSection";
import React, { useCallback } from "react";

import {
  FeedItemResponse,
  UserResponse,
} from "@every.org/common/src/codecs/entities";
import { FeedPage } from "@every.org/common/src/entity/types";
import { getUserJoinsFeedRouteSpec } from "@every.org/common/src/routes/users";

import { useLoggedInUserOrUndefined } from "src/context/AuthContext/hooks";
import { fetchFeed } from "src/context/DonationsContext/actions";

interface JoinsTabProps extends NoMoreFeedItemsCallbackProp {
  user: UserResponse;
  joinsFeed?: FeedItemResponse[];
}

export const JoinsTab = ({ user, joinsFeed, onNoMoreItems }: JoinsTabProps) => {
  const loggedInUser = useLoggedInUserOrUndefined();
  const isOwnProfile = user.id === loggedInUser?.id;

  if (!user) {
    return null;
  }

  return (
    <JoinsFeed
      userId={user.id}
      isOwnFeed={isOwnProfile}
      name={user.firstName}
      joinsFeed={joinsFeed}
      onNoMoreItems={onNoMoreItems}
    />
  );
};

interface JoinsFeedProps extends NoMoreFeedItemsCallbackProp {
  userId: UserResponse["id"];
  name?: string | null;
  isOwnFeed: boolean;
  joinsFeed?: FeedItemResponse[];
}

/**
 * Feed of donations from a given user.
 */
const JoinsFeed: React.FCC<JoinsFeedProps> = ({
  userId,
  name,
  isOwnFeed,
  joinsFeed,
  onNoMoreItems,
}) => {
  const noItemsDisplay = (
    <h3 css={{ textAlign: "center" }}>
      No one has publicly joined {name || "this person"} yet
    </h3>
  );

  return (
    <PageSection>
      <Feed
        initialItems={joinsFeed}
        page={FeedPage.USER_JOINS}
        loadMoreItems={useCallback(
          (params) =>
            fetchFeed({
              userId,
              ...params,
              feedRouteSpec: getUserJoinsFeedRouteSpec,
            }),
          [userId]
        )}
        noItemsDisplay={noItemsDisplay}
        onNoMoreItems={onNoMoreItems}
      />
    </PageSection>
  );
};
